export default "/aUSDbC.5eaf89566267f2c8c4d6256e23c8fc34.png";